export enum DefaultErrors {
  DEFAULT = "Something went wrong, please try again.",
}

export enum LoginErrors {
  INCORRECT_INPUT = "Incorrect email or password.",
}
